import type { TOC } from '@ember/component/template-only';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import { t } from 'ember-intl';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface SettingsMappingTableCellHeaderRoomNightsSignature {
  Args: {
    column: CustomEmberTableColumn;
  };
}

const SettingsMappingTableCellHeaderRoomNights = <template>
  <div class="flex items-center justify-between">
    <div class="flex items-center">
      <span class="mr-100">{{@column.name}}</span>
      <GeneralIconWithTooltip
        @side="top"
        @tooltipContent={{t "settings.pms_mapping.tooltip.room_nights"}}
      />
    </div>
  </div>
</template> satisfies TOC<SettingsMappingTableCellHeaderRoomNightsSignature>;

export default SettingsMappingTableCellHeaderRoomNights;
